import styled from 'styled-components';

import { COLORS } from '@theme/colors';

export const Container = styled.div<{ disabled: boolean }>`
  position: relative;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};

  &:hover {
    background-color: ${COLORS.BLACK};
    color: ${COLORS.WHITE};
  }
`;

export const Input = styled.input`
  display: none;
`;

export const CloseButton = styled.i`
  width: 12px;
  height: 12px;
  cursor: pointer;
  position: absolute;
  pointer-events: none;
  display: block;
  right: 6px;
  top: 50%;
  transform: translateY(-50%);

  &:before,
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 6px;
    height: 12px;
    width: 1px;
    background-color: black;
  }

  &:before {
    transform: rotate(45deg);
  }

  &:after {
    transform: rotate(-45deg);
  }
`;

export const Label = styled.label<{ fileName?: string }>`
  border: 1px solid black;
  position: relative;
  cursor: pointer;
  width: 100%;
  height: 34px;
  line-height: 34px;
  padding: 0 20px 0 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  text-align: ${({ fileName }) => (fileName ? 'left' : 'center')};
`;
